import { gql } from '@apollo/client';


const GET_PROGRESS = gql`
  query getProgress($usersId: [Int]! $userFlowId: Int!) {
    userFlow {
      getProgress(usersId: $usersId userFlowId: $userFlowId) {
        userFlowName
        userFlowId
        userId
        progress {
          userFlowStepId
          firstTracking {
            percentageCompleted
            started
            startedLongDate
            startedDate
            completedLongDate
            completedDate
            completed
            percentageCompleted
            userId
          }
          status
          name
        }
      }
    }
  }
`;

export { GET_PROGRESS };
